"use strict";
import { defineSlotRecipe } from '../../styled-system/config.js';
import { collapsibleAnatomy } from '@ark-ui/react/collapsible';

const collapsibleSlotRecipe = defineSlotRecipe({
  slots: collapsibleAnatomy.keys(),
  className: "chakra-collapsible",
  base: {
    content: {
      overflow: "hidden",
      _open: {
        animationName: "expand-height, fade-in",
        animationDuration: "moderate",
        "&[data-has-collapsed-size]": {
          animationName: "expand-height"
        }
      },
      _closed: {
        animationName: "collapse-height, fade-out",
        animationDuration: "moderate",
        "&[data-has-collapsed-size]": {
          animationName: "collapse-height"
        }
      }
    }
  }
});

export { collapsibleSlotRecipe };
